var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLeaf(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.125 5.4323C13.125 8.24261 11.5859 10.6025 9.27323 11.3671C8.8329 11.5416 8.35411 11.6409 7.85181 11.6409C6.42578 11.6409 5.10083 10.8387 4.43066 9.56515C3.24128 10.6622 2.92091 11.9162 2.91542 11.9404C2.85763 12.1823 2.6412 12.3449 2.4028 12.3449C2.36228 12.3449 2.3209 12.3401 2.27971 12.3305C1.99648 12.2624 1.82179 11.9772 1.88969 11.6942C2.10058 10.8262 3.87756 6.71955 9.25714 6.71955C9.45121 6.7199 9.60941 6.5617 9.60941 6.36834C9.60941 6.17498 9.45121 6.01678 9.25785 6.01678C6.89798 6.01678 5.19289 6.77703 3.99077 7.67791C3.99502 7.44017 4.01806 7.19803 4.06844 6.95172C4.36441 5.50569 5.51952 4.33696 6.95566 4.00298C7.57814 3.85879 8.1791 3.87085 8.73391 4.00286C9.96438 4.29553 11.3311 3.84 12.0144 2.65725C12.1389 2.4413 12.4543 2.44816 12.5563 2.67545C12.9207 3.48464 13.125 4.47649 13.125 5.4323Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLeaf);
export default __webpack_public_path__ + "static/media/leaf.8cd925a96e01bd7b86cfd29bea0db403.svg";
export { ForwardRef as ReactComponent };